import * as signalR from '@microsoft/signalr';
import Config from './config';

class UploadSignalRService {
	constructor() {
		this.connection = null;
		this.onProgress = null;
		this.onConcluido = null;
		this.onErro = null;
	}

	getHubUrl() {
		const baseUrl = Config.urls.API_URL_BASE.replace('/api/', '');
		const codUsuario = localStorage.getItem('CodUsuario');

		return `${baseUrl}/ws/uploadprogresshub?codUsuario=${codUsuario}`;
	}

	async start({ onProgress, onConcluido, onErro }) {
		this.onProgress = onProgress;
		this.onConcluido = onConcluido;
		this.onErro = onErro;

		this.connection = new signalR.HubConnectionBuilder()
			.withUrl(this.getHubUrl(), {
				accessTokenFactory: () => localStorage.getItem('AccessToken'),
				transport: signalR.HttpTransportType.WebSockets,
				skipNegotiation: true,
			})
			.withAutomaticReconnect()
			.build();

		this.connection.on('UploadProgress', (processados, total, mensagem) => {
			if (this.onProgress) this.onProgress(processados, total, mensagem);
		});

		this.connection.on('UploadConcluido', (resultadoJson) => {
			if (this.onConcluido) this.onConcluido(JSON.parse(resultadoJson));
		});

		this.connection.on('UploadErro', (erro) => {
			if (this.onErro) this.onErro(erro);
		});

		try {
			await this.connection.start();
		} catch (err) {
			console.error('Erro ao conectar SignalR upload:', err);
		}
	}

	async stop() {
		if (this.connection) {
			try {
				await this.connection.stop();
			} catch (err) {
				console.error('Erro ao desconectar SignalR upload:', err);
			}
			this.connection = null;
		}
	}
}

const uploadSignalR = new UploadSignalRService();
export default uploadSignalR;
